import ReactApexChart from "react-apexcharts";
import { Card, CardBody, CardFooter, Col } from "reactstrap";
import { GoalSummaryTitle } from "../../../../Constants/Constants";
import { Goal, GoalSummaryData } from "../../../../Data/General/Dashboard/Ecommerce";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { H5, LI, UL } from "../../../../AbstractElements";

const GoalSummary = () => {
  return (
    <Col xxl="4" xl="5" md="6" className="box-col-5">
      <Card className="goal-view">
        <DashboardCommonHeader title={GoalSummaryTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div className="goal-chart">
            <div className="shape-block">
              <div className="rounded-shape"><i /><i /><i /></div>
            </div>
            <div id="goal" className="goal">
              <ReactApexChart options={Goal} series={Goal.series} type="radialBar" height={345} />
            </div>
          </div>
        </CardBody>
        <CardFooter>
          <UL className="simple-list flex-row">
            {GoalSummaryData.map((item, index) => (
              <LI key={index}>
                <H5 className="f-w-600">{item.price}</H5>
                <span className="f-w-500">{item.title}</span>
              </LI>
            ))}
          </UL>
        </CardFooter>
      </Card>
    </Col>
  );
};

export default GoalSummary;
